/** @file Request utility for API calls */

import { createDefaultHeaders, getJSONOrThrow } from '../api';
import { getSession, urlWithAdminQuery } from '../auth';

interface RequestOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: string;
  headers?: Record<string, string>;
}

/**
 * Generic request utility function
 *
 * @param {string} endpoint - API endpoint (without base URL)
 * @param {RequestOptions} options - Request options
 * @returns {Promise<any>} - Promise resolving to response data
 */
export const request = async (endpoint: string, options: RequestOptions): Promise<any> => {
  const session = await getSession();

  const headers = createDefaultHeaders({
    authToken: session.idToken.toString(),
  });

  // Add any additional headers
  if (options.headers) {
    Object.entries(options.headers).forEach(([key, value]) => {
      headers.set(key, value);
    });
  }

  const response = await fetch(urlWithAdminQuery(`/${endpoint}`, session.adminEmail), {
    method: options.method,
    headers,
    body: options.body,
  });

  return getJSONOrThrow(response);
};
